<template>
  <div class="gallery" aria-hidden="true">
    <figure v-if="images[0]" class="gallery_main">
      <div>
        <a @click.prevent.stop="openZoomModal" :href="initialImage" :data-href="initialImage" :style="'background-image:url('+initialImage+')'">
          <span class="g-clip">{{ images[0].caption }}</span>
        </a>
        <i class="g-i g-i-zoom" aria-hidden="true"></i>
      </div>
      <figcaption v-if="images[0].caption">{{ images[0].caption }}</figcaption>
    </figure>
    <div v-if="images[0]" class="gallery_carousel">
      <div v-swiper:Swiper="swiperOption">
        <ul class="swiper-wrapper">
          <li v-for="(image, index) in showImages" :key="image.url" class="swiper-slide">
            <div></div>
            <a :href="image.thumbnail" :data-large="image.url" :data-thumb="image.thumbnail" :style="'background-image:url('+image.thumbnail+')'" :aria-selected="[index ? 'false' : 'true']">
              <span class="g-clip">{{ image.caption }}</span>
            </a>
          </li>
        </ul>
      </div>
      <div class="gallery_carousel_prev"><i class="g-i g-i-arrow" aria-hidden="true"></i></div>
      <div class="gallery_carousel_next"><i class="g-i g-i-arrow" aria-hidden="true"></i></div>
    </div>
  </div>
</template>

<script>
import i18n from '@/i18n.js'
import { directive } from 'vue-awesome-swiper'
import 'swiper/css/swiper.css'

export default {
  directives: {
    swiper: directive
  },
  props: {
    images: { type: Array, required: true },
  },
  watch: { 
    images: function() {
      this.setInitialImage()
    }
  },
  data () {
    return {
      swiperOption: {
        slidesPerView: 4,
        spaceBetween: 12,
        navigation: {
          nextEl: '.gallery_carousel_next',
          prevEl: '.gallery_carousel_prev'
        }
      },
      initialImage: ''
    }
  },
  computed: {
    showImages: function() {
      let images = []
      let i = 0
      for(i; i < this.images.length; i++) {
        if(this.images[i].url) {
          images.push(this.images[i])
        }
      }
      return images
    }
  },
  filters: {
    // 配列になっている値の結合
    join (val) {
      if (Array.isArray(val)) {
        return val.length ? val.join(', ') : "-"
      } else {
        return val ? val : "-"
      }
    },
    // 英語ページの場合は英語ページへのリンクにする
    lang (path) {
      return i18n.locale == 'en' ? '/en'+path : path
    }
  },
  created: function() {
    this.setInitialImage()
  },
  methods: {
    // Modal
    openZoomModal(event) {
      this.$emit('parentFunc', event.currentTarget.getAttribute('href'))
    },
    // 画像のURLを返却する（構成際画像がない場合はサムネイルを表示させる）
    async getImageUrl(full, thumb) {
      return new Promise((resolve) => {
        const img = new Image()
        img.onload = () => {
          resolve(full)
        }
        img.onerror = () => {
          resolve(thumb)
        }
        img.src = full;
      })
    },
    // 初期のメイン画像を決定する
    setInitialImage() {
      this.getImageUrl(this.images[0].url, this.images[0].thumbnail)
      .then(url => {
        this.initialImage = url
      })
    }
  },
}
</script>
